import React from 'react';
import proptypes from 'prop-types';
const { arrayOf, string } = proptypes;
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';

const getApplianceAlert = (addons = []) => {
  const hasCoverage = addons.some(
    (addon) => addon?.selected && addon?.category === 'protectionPlan'
  );
  const hasInstallation = addons.some(
    (addon) => addon?.selected && (
      (addon?.category === 'required' && addon?.type === 'INSTALL')
      || (addon?.category === 'applianceConfig' && addon?.configAttr === 'Hookup')
    )
  );
  const selections = ['appliance', hasInstallation && 'installation', hasCoverage && 'coverage'].filter(Boolean);
  const hasAddOns = selections.length > 1;
  const last = selections[selections.length - 1];
  const rest = selections.slice(0, -1);
  return {
    status: hasAddOns ? 'success' : 'info',
    message: hasAddOns
      ? `Your ${rest.join(', ')} and ${last} selections have been added to cart.`
      : 'Your appliance has been added to cart. Make installation and coverage selections in cart or during checkout.'
  };
};

export const Confirmation = ({
  lineItemIds,
  cartDirectData = null
}) => {
  const allCartItems = cartDirectData?.data?.updateCart?.items
    || cartDirectData?.data?.addToCart?.items
    || [];
  const newCartItems = allCartItems.filter(({ id }) => lineItemIds.includes(id));

  return (
    <div data-testid="confirmation-page" className="sui-flex sui-flex-col sui-h-full">
      {newCartItems.map((cartItem) => {
        const alert = getApplianceAlert(cartItem.product?.addons);
        const { product, quantity, id } = cartItem;
        const { identifiers, media, pricing } = product || {};
        const { brandName, productLabel, canonicalUrl } = identifiers || {};
        const imageUrl = media?.images?.[0]?.url;
        const price = pricing?.value || pricing?.original;
        return (
          <div key={id}>
            <div className="sui-flex sui-items-start sui-gap-3">
              <Link href={canonicalUrl} target="_top" className="sui-no-underline sui-shrink-0">
                <img
                  src={imageUrl}
                  height={74}
                  width={74}
                  alt={productLabel}
                />
              </Link>
              <div className="sui-flex-1 sui-min-w-0">
                <Link href={canonicalUrl} target="_top" className="sui-no-underline">
                  <Typography lineClamp="3">
                    <div className="sui-font-bold">{brandName}</div>
                    <div>{productLabel}</div>
                  </Typography>
                </Link>
                {quantity && price && (
                  <div className="sui-flex sui-justify-between sui-pt-2">
                    <Typography>Qty: {quantity}</Typography>
                    <Typography weight="bold">${price}</Typography>
                  </div>
                )}
              </div>
            </div>
            <div className="sui-mt-4">
              <Alert status={alert.status}>
                {alert.message}
              </Alert>
            </div>
          </div>
        );
      })}
    </div>
  );
};

Confirmation.propTypes = {
  lineItemIds: arrayOf(string).isRequired,
  cartDirectData: proptypes.object
};

Confirmation.displayName = 'Confirmation';
